import { Dialog } from "@headlessui/react"
import { KTitleSpan, KSpan, KButton } from "kahuna-base-react-components"
import React, { useEffect } from "react"
import { lang } from "../../../constants/languages"
import { User } from "../../../types"
import { toast } from "react-toastify"
import { errorFilledToastOptions } from "../../../constants"
import { users } from "../../../apis"
import { useNavigate } from "react-router-dom"

const ChangeUserModal = ({
  open,
  setOpen,
  userMembers,
  fetchUserData
}: {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  userMembers: User[]
  fetchUserData: () => Promise<void>
}) => {
  const navigate = useNavigate()

  const onChangeUser = (userId?: number) => {
    if (!userId) {
      return
    }
    users(`/change_user/?user_id=${userId}`, "get")
      .then((resp) => {
        if (resp?.data?.token) {
          localStorage.setItem("token", resp.data.token)
          localStorage.setItem("cgba", "1")
          fetchUserData().then(() => {
            navigate("/")
          })
        } else {
          toast.error(lang.menu.change_user_modal.error_changing_user, errorFilledToastOptions)
        }
      })
      .catch(() => toast.error(lang.menu.change_user_modal.error_changing_user, errorFilledToastOptions))
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div className="p-6 shadow-md w-[400px] rounded-[10px] bg-[#fff]">
          <div className="mb-4">
            <KTitleSpan fontSize={20} lineHeight="20px" text={lang.menu.change_user_modal.title} />
          </div>
          <div className="mb-4">
            <KSpan fontSize={14} text={lang.menu.change_user_modal.description} />
          </div>
          <div>
            {userMembers?.map((userMember: User) => {
              return (
                <div
                  className="flex gap-2 py-2.5 pl-1 items-center hover:bg-[#F0F0F0] cursor-pointer"
                  key={`user_member_${userMember.id}`}
                  onClick={() => onChangeUser(userMember.id)}
                >
                  <img
                    style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                    src={userMember.photo || "/account_icons/avatar.svg"}
                  />
                  <KSpan fontSize={16} text={`${userMember.firstName} ${userMember.lastName}`} />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default ChangeUserModal
